import Vue from 'vue'
import Router from 'vue-router'
import routesArray from './module'
import Msg from '@asst/js/msg'

Vue.use(Router)

let router = new Router({
  // mode: 'hash',
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      component: () => import('@view/login/login')
    },
    {
      meta: {
        requireAuth: true // 配置进入此页面前是否需要登入
      },
      path: '/home',
      component: () => import('@view/home/home'),
      children: routesArray
    },
    {
      path: '/login',
      component: () => import('@view/login/login')
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (!sessionStorage.getItem('userName')) { // 查询本地存储信息是否已经登陆
      Msg.alert('请先登录')
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js